.path {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.blocker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 600;
}

.word {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.link {
  font-size: var(--t-dense);
  font-weight: 500;
}
